import React, { useEffect, useRef } from 'react';

interface SplashScreenProps {
  onComplete: () => void;
  minDisplayTime?: number;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({
  onComplete,
  minDisplayTime = 1500,
}) => {
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const timer = setTimeout(() => {
      onCompleteRef.current();
    }, minDisplayTime);

    return () => clearTimeout(timer);
  }, [minDisplayTime]);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-white">
      <svg className="w-10 h-10 animate-spin" viewBox="0 0 50 50" fill="none">
        <defs>
          <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3451D1" />
            <stop offset="40%" stopColor="#4361EE" />
            <stop offset="100%" stopColor="#6B8AFF" />
          </linearGradient>
        </defs>
        <circle cx="25" cy="25" r="20" stroke="#E5E7EB" strokeWidth="4" />
        <path
          d="M25 5 A20 20 0 0 1 45 25"
          stroke="url(#spinner-gradient)"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
